module.exports = __webpack_public_path__ + "fonts/iconfont.a32c5f14.eot";